import { apiUtils } from '../utils/apiUtils'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  upsert: function (code, fournisseur) {
    return fetch(apiUtils.integrationEnroll + '/fournisseur/' + code, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(fournisseur)
    })
  },
  remove: function (code, fournisseur) {
    return fetch(apiUtils.integrationEnroll + '/fournisseur/' + code, {
      method: 'DELETE',
      headers: jsonHeaders,
      body: JSON.stringify({ idfournisseur: fournisseur.idfournisseur })
    })
  }
}